<template>
    <b-modal hide-footer id="addressModal" size="lg" title="Atualização de endereço">
        <p>Estamos solicitando a atualização dos dados de endereço dos nosso usuários por favor preenhcha os campos abaixo</p>
        <b-overlay :show="loading">
            <address-form @submited="submit" :errors="errors"/>
        </b-overlay>
    </b-modal>
</template>

<script>
import hasErrors from '../components/HasError.vue'
import AddressForm from './AddressForm.vue'

export default {
    components: {
        hasErrors,
        AddressForm
    },  
    props: ['data'],
    data(){
        return {
            loading: false,
            errors: {},
        }
    },
    created(){

        if (this.data.can_show) {
            this.$nextTick(() => {
                this.$bvModal.show('addressModal')
            })
        }
    },
    methods: {
        submit(form){
            this.loading= true

            this.errors = {}

            axios.post(this.data.endpoint_address, {
                address: form.street,
                zip_code: form.zip_code,
                city: form.city,
                state: form.state,
                number: form.number,
                country: 'BR'

            })
            .then((result) => {
                this.$toast.success('Atualizado com sucesso')
                this.$bvModal.hide('addressModal')
            }).catch((errors) => {
                this.errors = this.setErrors(errors)
            })
            .finally(()=> this.loading = false);
        }
    }
}
</script>

<style>

</style>
